// extracted by mini-css-extract-plugin
export var footer = "_r7-0";
export var inherit = "_r7-1";
export var input = "_r7-2";
export var modalContent = "_r7-3";
export var quillEditor = "_r7-4";
export var subtitle = "_r7-5";